var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import './SelectRestaurantClient.scss';
import Select, { components } from 'react-select';
import Loader from '@/components/Loader/Loader';
import { useAppSelector } from '@/hooks/redux';
import { useGetUserByIdQuery } from '@/services/usersApi';
var SelectRestaurantClient = function (_a) {
    var _b, _c;
    var restaurant = _a.restaurant, setRestaurant = _a.setRestaurant, isLoading = _a.isLoading, defaultValue = _a.defaultValue;
    var user = useAppSelector(function (state) { return state.authStich.currentUser; });
    var _d = useState(defaultValue), myDefaultValue = _d[0], setMyDefaultValue = _d[1];
    var _e = useState(null), selectedOption = _e[0], setSelectedOption = _e[1];
    var currentUserRole = (_b = user === null || user === void 0 ? void 0 : user.role) === null || _b === void 0 ? void 0 : _b.role;
    var isClient = currentUserRole === 'сотрудник';
    var _f = useGetUserByIdQuery({ id: user === null || user === void 0 ? void 0 : user.id }), userData = _f.data, isUserDataSuccess = _f.isSuccess;
    var restId = (_c = userData === null || userData === void 0 ? void 0 : userData.restaurant) === null || _c === void 0 ? void 0 : _c.id;
    var BodyTextOne = useCallback(function (_a) {
        var title = _a.title, size = _a.size;
        return (_jsx("div", __assign({ style: size ? { fontSize: size } : {}, className: "BodyTextOne" }, { children: title })));
    }, []);
    useEffect(function () {
        if (defaultValue) {
            setMyDefaultValue(defaultValue);
            setSelectedOption({
                value: defaultValue.id,
                label: _jsx("div", { children: defaultValue.name || 'No name available' }),
                restaurant: defaultValue
            });
        }
    }, [defaultValue]);
    var options = restaurant
        .filter(function (item) { return isClient && item.id === restId || !isClient; })
        .map(function (item) { return ({ value: item.id, label: _jsx(BodyTextOne, { title: item.name }), restaurant: item }); });
    var CustomInput = useCallback(function (props) {
        return _jsx(components.Input, __assign({}, props, { readOnly: true }));
    }, []);
    var handleChange = function (selected) {
        console.log('selected', selected);
        setRestaurant(selected.restaurant);
        setSelectedOption(selected);
    };
    if (isLoading)
        return _jsx("div", __assign({ style: { marginBottom: '20px' } }, { children: _jsx(Loader, { width: '24px', height: '24px' }) }));
    if (restaurant.length === 0) {
        return _jsx("div", __assign({ className: "empty-list" }, { children: "\u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0441\u043D\u0430\u0447\u0430\u043B\u0430 \u0441\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u0437\u0430\u0432\u0435\u0434\u0435\u043D\u0438\u0435" }));
    }
    return (_jsx(Select, { components: { Input: CustomInput }, styles: {
            control: function (base, state) {
                return (__assign(__assign({}, base), { borderRadius: '8px', borderBottomRightRadius: state.menuIsOpen ? 0 : '8px', borderBottomLeftRadius: state.menuIsOpen ? 0 : '8px', backgroundColor: 'white', border: '1px solid #E3E3E3', boxShadow: state.isFocused ? '0 0 0 1px #E3E3E3' : 'none', '&:hover': {
                        border: '1px solid #E3E3E3',
                    } }));
            },
            dropdownIndicator: function (base, state) { return (__assign(__assign({}, base), { color: '#000000', transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease', paddingLeft: '0px', paddingRight: '0px', marginLeft: '0px', marginRight: '12px' })); },
            indicatorSeparator: function (base) { return (__assign(__assign({}, base), { display: 'none' })); },
            option: function (base, state) {
                return (__assign(__assign({}, base), { backgroundColor: state.isSelected ? '#E3E3E3' : 'white', color: 'black', '&:hover': {
                        backgroundColor: '#E3E3E3',
                    } }));
            },
            menu: function (base) { return (__assign(__assign({}, base), { marginTop: '0px', borderBottomRightRadius: '8px', borderBottomLeftRadius: '8px', borderTopRightRadius: '0px', borderTopLeftRadius: '0px', border: '1px solid #E3E3E3', borderTopWidth: 0, height: '100px' })); },
            menuList: function (base) { return (__assign(__assign({}, base), { color: 'black', padding: '0px', height: '100px', borderBottomRightRadius: '8px', borderBottomLeftRadius: '8px' })); },
            singleValue: function (base) { return (__assign(__assign({}, base), { color: 'black' })); },
        }, value: selectedOption, className: "SelectRestaurantClient", onChange: handleChange, options: options, placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0437\u0430\u0432\u0435\u0434\u0435\u043D\u0438\u0435", isDisabled: restaurant.length === 0 }));
};
export default SelectRestaurantClient;
